export const en = {
  updatePasswordDisabled:
    'Single Sign-On (SSO) is enabled for your account. Please reach out to support with any issues.'
};

export type Translations = typeof en;
